<div class="header">
  <div layout-align-items-center layout-horizontal>
    <rt-badge color="ai" [text]="'app.common.ai' | translate" />
    <span>{{ 'app.evaluation_insights.insight.insights' | translate }}</span>
  </div>
</div>
<div class="content">
  @let insightValue = insight();
  <div class="main">
    @if (insightValue.stale && !isLoading()) {
      <div class="stale">
        <span text-weight-semi-bold layout layout-align-items-center>
          {{ 'app.evaluation_insights.insight.stale.header' | translate }}
          <rt-icon
            name="info-outline"
            colorToken="colorIconOntellentDefault"
            [rtTooltip]="'app.evaluation_insights.insight.stale.tooltip' | translate"
            [rtTooltipMaxWidth]="370"
            [rtTooltipPosition]="'right'"
            margin-left-small-x
          />
        </span>
        <rt-button variant="outline-ghost" size="small" (click)="refresh.emit()">
          <rt-icon name="refresh" />
          {{ 'app.evaluation_insights.insight.stale.refresh' | translate }}
        </rt-button>
      </div>
    }
    <div class="main-header">
      <div layout layout-vertical>
        @if (offer(); as offer) {
          <div layout layout-align-items-center>
            <rt-offer-status-indicator [offerStatus]="offer" margin-right-small-xx />
            <span>{{ offer.title }}</span>
          </div>
        }
      </div>
      <div class="main-header--right">
        @if (!isLoading()) {
          <div [rtTooltip]="insightValue.updatedAt | amDateFormat: 'lll'" class="time-created">
            {{
              'app.evaluation_insights.insight.generated_time_ago'
                | translate: { timeAgo: insightValue.updatedAt | rtTimeAgo }
            }}
          </div>
        }
        <span class="separator"></span>
        <rt-select2
          [items]="analyticsOptions"
          [formControl]="analyticsFormControl"
          (selection)="onAnalytics()"
        >
          <rt-select-trigger-button
            *rtSelectTrigger
            icon="flag"
            [label]="'app.evaluation_insights.insight.is_helpful' | translate"
            [disabled]="isLoading()"
          />
        </rt-select2>
      </div>
    </div>
    <rt-divider class="main-divider" />
    <div
      class="content-container"
      [class.small]="expandable() && !isExpanded()"
      [class.is-loading]="isLoading()"
    >
      @if (isLoading()) {
        <rt-placeloader class="placeloader" variant="ai" />
        <rt-placeloader class="placeloader" variant="ai" />
        <rt-placeloader class="placeloader" variant="ai" />
      } @else {
        <rt-icon-button
          [rtTooltip]="'app.common.copy_to_clipboard' | translate"
          (click)="copyToClipboard()"
          variant="plain"
          iconName="content-copy"
          shape="square"
          class="copy"
          margin-top-small-xx
        />
        <div #insightElement [innerHTML]="insightValue.content" class="insight"></div>
      }
    </div>
    @if (expandable() && !isLoading()) {
      <rt-button
        (click)="isExpanded.set(!isExpanded())"
        layout-align-self-start
        margin-top-medium
        class="show-more-button"
      >
        {{ (isExpanded() ? 'app.common.show_less' : 'app.common.show_more') | translate }}
      </rt-button>
    }
    @if (isExpanded()) {
      <rt-divider class="main-divider" margin-bottom-medium />
      @if (!isLoading()) {
        <div class="based-on-section" layout layout-align-items-center>
          <div text-weight-semi-bold>
            <span text-darkest>{{ 'app.evaluation_insights.insight.based_on' | translate }}</span>
            &ngsp;
            <a [routerLink]="completedTabRouterLink()" class="text-active">
              {{
                'app.evaluation_insights.insight.x_completed_evaluations'
                  | translate: { count: insightValue.sources.length }
              }}
            </a>
          </div>
          <rt-admins-avatars [admins]="allUsers()" [stacked]="true" margin-left-small-x />
        </div>
      }
    }
    <div class="footer">
      <span text-bold text-darkest>{{ 'app.evaluation_insights.insight.note' | translate }}</span>
      {{ 'app.evaluation_insights.insight.ai_disclaimer' | translate }}
    </div>
  </div>
</div>
